const BaseDirectories = {
  /** Directories and folders. */
  IMAGES_DIR: '../assets/images',
  LOGOS_DIR: '../assets/logos',
  ICONS_DIR: '/assets/icons',
};

export default BaseDirectories;
